// import { Icon } from "../Icon/Icon";

interface ChipProps {
  label: string;
  onDelete?: () => void; // Optional for chips without delete functionality
  isIcon?: boolean;
  size?: "small" | "large";
  onClick?: () => void;
  isSelected?: boolean; 
}

export const Chip = ({
  label,
  isIcon,
  size,
  onDelete,
  onClick,
  isSelected = false,
}: ChipProps) => {
  return (
    <div
      className={`t2-chip ${
        size === "small" ? "t2-chip--small" : "t2-chip--large"
      } ${isSelected ? "t2-chip--selected" : ""}`}
      onClick={onDelete ? onDelete : onClick}
    >
      <span
        className={`t2-chip__label ${!isIcon ? "t2-chip__label--no-icon" : ""}`}
      >
        {label}
      </span>

      {isIcon && onDelete && (
        <button
          className="t2-chip__delete"
          aria-label={`Remove ${label}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          X
          {/* <Icon type="t2u-close" className="t2-chip__close-icon" size={12} /> */}
        </button>
      )}
    </div>
  );
};